import moment from "moment";
import fileSys from "../../../fileoprators/fileSystem";
import { logStdout } from "../../../shared/utils";
const { Parser } = window.require("json2csv");
const fs = window.require("fs");
const { execSync, spawn, exec } = window.require("child_process");
export const mkdir = (folderName, storage, patient, record, osod, langcfg) => {
  const dstpath = fileSys.combinePath(
    storage,
    fileSys.normalExportName(folderName, patient, record, osod, langcfg)
  );
  try {
    if (!fileSys.isFileExists(dstpath)) {
      execSync(`mkdir -p "${dstpath}"`);
    }
    logStdout("export mkdir success", dstpath);
    return { message: "ok", path: dstpath };
  } catch (e) {
    logStdout("export mkdir error", e.message);
    return { message: e.message };
  }
};
export const makeCSVpath = (storage) => {
  try {
    let dst = [];
    dst.push("DEA520");
    dst.push(moment().format("YYYYMMDD_HHmmss"));
    if (!fileSys.isFileExists(storage)) {
      execSync(`mkdir -p "${storage}"`);
    }
    let dir = `${fileSys.combinePath(storage, dst.join("_"))}.csv`;
    return dir;
  } catch (e) {}
};
export const json2CSV = (headers, data, filepath = "D:\\xxx.csv") => {
  const parser = new Parser({ fields: headers });
  fileSys.writeFile(filepath, parser.parse(data), (err) => {
    console.log(err);
  });
};
export const getFileSize = (filepath) => {
  try {
    return fs.statSync(filepath).size;
  } catch (e) {}
};
export const getFreeSpace = () => {
  try {
    const result = execSync(`df | grep -w /dev/sda6 | awk -F ' ' '{print $3}'`);
    return parseInt(result);
  } catch (e) {}
};
export const getUdiskFreeSpace = () => {
  if (fileSys.isUDiskExits().status) {
    return parseInt(window.usbDriver.available) * 1024;
  }
};
export const copy2Udisk = (src, dst, callback) => {
  if (getFileSize(src) < getUdiskFreeSpace()) {
    exec(`rsync -rltDvz ${src} ${dst} 1>/dev/null`, (err) => {
      fileSys.deleteFile(src);
      if (callback) callback(err);
    });
  } else {
    fileSys.deleteFile(src);
    callback(new Error("free space not enough"));
  }
};
export const compressFile = (src, dst, callback) => {
  const sp = spawn("tar", ["-cf", dst, src]);
  sp.on("error", (err) => {
    callback(err);
  });
  sp.on("data", (data) => {});
  sp.on("close", (code) => {
    if (code === 0) {
      callback();
    } else {
      callback(new Error("export failed"));
    }
  });
};



// WEBPACK FOOTER //
// ./src/mainInterface/components/exportData/funcs.js